<div class="submit-info-page-container">
  @if (!showStepperScreen) {
  <ng-container [ngTemplateOutlet]="languageSwitch"></ng-container>
  }
  <div class="container-width">
    @if (!showStepperScreen && !alreadySubmitted && !isSubmitted) {
    <div class="intro-section"
         [ngClass]="{'ios' : platform.IOS}">
      <div class="text-center">
        <img alt="addenda-logo"
             src="assets/img/addenda.png">
        <div class="logo-border"></div>
        <h3 class="heading">{{'welcome_to_addenda' | translate}}</h3>
        <p class="sub-heading">{{'customer_journey_welcome_screen_subheading' | translate}}</p>
      </div>
      <div class="mandatory-section">
        @if (isMandatory()) {
        <span class="mandatory-index">{{'mandatory_to_provide' | translate }}</span>
        }
      </div>
      @for (step of requestedSteps; track step; let i = $index) {
      <div class="card"
           [ngClass]="{'last-child' : (i === requestedSteps?.length - 1)}">
        <div class="step-no">{{'step' | translate }} {{i+1}}</div>
        <div class="step-info">{{step.text | translate}}
          @if (step.subStep?.length > 0 ) {
          <ul>
            @for (subSep of step.subStep; track subSep) {
            <li>
              <span class="card-value">{{subSep.name | translate}}</span>
              @if (subSep.mandatory) {
              <span style="color:red">&nbsp;*</span>
              }
            </li>
            }
          </ul>
          }
        </div>
      </div>
      }
      <div class="text-center">
        <xa-button size="lg"
                   class="footer-button"
                   (click)="goToStepper();">{{'lets_get_started' | translate}}</xa-button>
      </div>
    </div>
    }
    @if (showStepperScreen) {
    <div>
      <div class="header">
        <div class="back"
             (click)="handleBackAction();"><span class="back-arrow"><mat-icon
                      [svgIcon]="'left-arrow-round-filled'"></mat-icon></span>{{'back' | translate}}</div>
        <div class="header-actions">
          <!-- @if (mediaDocumentUpload && !mediaDocumentUpload?.currentStep?.mandatory && mediaDocumentUpload?.files?.length
          === 0) {
          <div class="skip"
               (click)="handleSkip();"><span class="back-arrow pointer">{{'skip' | translate}}</span></div>
          }
          @if (videoInspectionItemTemplate && videoInspectionItemTemplate?.isSkipEnabled && activeStep?.toLowerCase()
          ===
          'video') {
          <div class="back"
               (click)="handleVideoSkip();"><span class="back-arrow pointer">{{'skip' | translate}}</span></div>
          } -->
          <ng-container [ngTemplateOutlet]="languageSwitch"></ng-container>
        </div>
      </div>
      <mat-stepper #stepper
                   [linear]="true">
        <ng-template matStepperIcon="edit">
          <mat-icon [svgIcon]="'check'"></mat-icon>
        </ng-template>
        @for (step of requestedSteps; track step; let i = $index) {
        <mat-step [label]="step.stepperTitle | translate"
                  [completed]="step.completed">
          @if (step.step === 'review') {
          <div class="review-section">
            <div class="scroll-section"
                 [ngClass]="{'ios' : platform.IOS}">
              <div class="text-center page-into">{{'please_preview_your_details_before_uploading' | translate}}</div>
              <div class="card mt-5">
                <h5 class="card-heading">{{'customer_details' | translate}}</h5>
                <div class="row">
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'name' | translate}}</label>
                    <div class="card-value">{{customerName}}</div>
                  </div>
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'email_id' | translate}}</label>
                    <div class="card-value">{{caseDetails?.driverDetails?.email}}</div>
                  </div>
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'phone_number' | translate}}</label>
                    <div class="card-value">{{customerMobileNo}}</div>
                  </div>
                </div>
              </div>
              <div class="card mt-5">
                <h5 class="card-heading">{{'vehicle_detail' | translate}}</h5>
                <div class="row">
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'make' | translate}}</label>
                    <div class="card-value">{{caseDetails?.vehicleMetaData?.make}}</div>
                  </div>
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'model' | translate}}</label>
                    <div class="card-value">{{caseDetails?.vehicleMetaData?.model}}</div>
                  </div>
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'type' | translate}}</label>
                    <div class="card-value">{{caseDetails?.vehicleMetaData?.vehicleType}}</div>
                  </div>
                  <div class="col-6">
                    <label for=""
                           class="card-label">{{'vin' | translate}}</label>
                    <div class="card-value">{{caseDetails?.vehicleMetaData?.vinNum}}</div>
                  </div>
                </div>
              </div>
              @for (step of requestedSteps; track step; let i = $index) {
              @if (step.step !== 'review') {
              <div class="card mt-5">
                <div class="d-flex">
                  <h5 class="card-heading">{{step.reviewScreenText | translate}}</h5>
                  <mat-icon [svgIcon]="'edit'"
                            (click)="goToStep(i);"
                            class="ml-auto edit-icon"></mat-icon>
                </div>
                @if (step?.subStep?.length > 0) {
                <div>
                  <ul>
                    @for (subStep of step?.subStep; track subStep) {
                    <li [ngClass]="{'hasImage':hasValue(subStep.name,step.step)}"><span
                            class="card-value">{{subStep.name | translate}}</span></li>
                    }
                  </ul>
                </div>
                }
                @if (step.step === 'video') {
                <div>
                  <ul>
                    <li [ngClass]="{'hasImage':hasValue('video','video')}"><span
                            class="card-value">{{'inspection_video'| translate}}</span></li>
                  </ul>
                </div>
                }
              </div>
              }
              }
            </div>
            <div class="text-center final-review-button">
              <xa-button size="lg"
                         (click)="submitForm();">{{'submit'| translate}}</xa-button>
            </div>
          </div>
          }
          @if (step.step === 'document') {
          <div class="text-center">
            <media-upload title="{{activeChildDocumentStepIndex ===0 && activeDocumentStepIndex === 0 ?  'start_document_title': ''}}"
                          #mediaDocumentUpload
                          [hidden]="this.activeDocumentSteps?.length === 0"
                          [name]="this.activeDocumentSteps[activeChildDocumentStepIndex]?.stepName"
                          buttonText="upload_document_btn"
                          reviewTitle="documents_review"
                          [image]="this.activeDocumentSteps[activeChildDocumentStepIndex]?.placeHolderUrl"
                          module="document"
                          [objectId]="objectId"
                          [domainID]="domainId"
                          [hideOutlineImg]="true"
                          [steps]="this.activeDocumentSteps"
                          [options]="documentOptions"
                          (nextStep)="handleDocumentNext(i);"
                          (documentStepsLoaded)="onDocumentLoad($event);"
                          (documentFileUploaded)="handleActiveDocumentChange($event);"
                          (fileUploaded)="handleImageChange($event,i);"
                          subtitle="{{'start_document_description' | translate:{stepName: (this.activeDocumentSteps[activeChildDocumentStepIndex]?.parentName | translate)} }}"
                          (skipStep)="handleSkip();">
              <div class="doc-description">
                <span>{{'max_file_extension' | translate:{ fileSize:
                  this.activeDocumentSteps[activeChildDocumentStepIndex]?.sizeLimit/(1024 * 1024) } }}</span>
                <span>{{'supported_formats' | translate:{ extensions: activeDocumentExtensions } }}</span>
              </div>
            </media-upload>
          </div>
          }
          @if (step.step === 'photo') {
          <div class="text-center">
            @if (stepper.selectedIndex === i) {
            <media-upload title="capture_image_title"
                          name="photos"
                          buttonText="camera_image"
                          reviewTitle="images_next"
                          [module]="aiCamera ? 'ai' : 'image'"
                          [steps]="this.steps"
                          [vehicleType]="caseDetails?.vehicleMetaData?.vehicleType"
                          (nextStep)="nextStep(i);"
                          (fileUploaded)="handleImageChange($event,i);"
                          subtitle="lets_upload"
                          (skipStep)="handlePhotoSkip();">
              <div class="video-description">
                <ul class="no-marker">
                  <li>{{'capture_angles' | translate:{ sides: (sideCount || '0'), steps: sideNames } }}</li>
                </ul>
              </div>
            </media-upload>
            }
          </div>
          }
          @if (step.step === 'video') {
          <div class="text-center">
            <media-upload title="capture_video_title"
                          name="video"
                          #videoComponent
                          buttonText="start_capture"
                          reviewTitle="{{(videoComponent?.localVideoUrl) ?'video_to_uploaded': ( videoComponent?.currentStep?.url ? 'video_uploaded':'please_upload_video')}}"
                          module="video"
                          (nextStep)="nextStep(i);"
                          [steps]="[this.videoInspectionItemTemplate]"
                          (videoUploaded)="handleFileChange($event,i);"
                          subtitle="complete_video"
                          (skipStep)="handleVideoSkip();">
              <div class="video-description">
                <span><strong>{{'note' |translate}}:</strong>{{'capture_instruction' | translate}}</span>
                <ul>
                  <li>{{'capture_instruction_chassis' | translate}}
                    <xa-button type="basic"
                               size="sm"
                               (click)="openVideoInstruction();"
                               class="info">
                      {{'find_where' | translate}}
                    </xa-button>
                  </li>
                  <li>{{'capture_instruction_lighting' | translate}}</li>
                </ul>
              </div>
            </media-upload>
          </div>
          }
        </mat-step>
        }
      </mat-stepper>
    </div>
    }

    @if (alreadySubmitted || isSubmitted) {
    <div class="thankyou-section">
      <div>
        <mat-icon [svgIcon]="'case-submit-info-thank-you'"></mat-icon>
        <h5 class="mt-5 thank-you-text">{{'thank_you' | translate}}</h5>
        <p class="details">{{'submit_screen_thank_you_message' | translate}}</p>
      </div>
    </div>
    }
  </div>
</div>

<ng-template #languageSwitch>
  <div class="language-switch">
    @for (item of languages; track item.Code; let last = $last) {
    <button class="link"
            type="button"
            [ngClass]="{'selected': item.Code === selectedLang}"
            (click)="onLangChange(item.Code)">{{item.Name}}</button>
    @if (!last) {
    <div class="divider"></div>
    }
    }
  </div>
</ng-template>